import { OrderStatuses } from 'constants/orderStatuses';
import { Resources } from 'constants/resources';

import { useCallback, useMemo } from 'react';

import { AdjustmentConfig } from 'pages/OrderAdjustments/constants/adjustmentConfigs';
import { OrderAdjustmentsOrder } from 'pages/OrderAdjustments/types';
import { useGetList } from 'react-admin';
import { OrderStatus } from 'types/embedded/orderStatus';

export function useIsOrderAdjustmentAllowed(): (
  config: AdjustmentConfig,
  orders: OrderAdjustmentsOrder[],
) => boolean {
  const { data: orderStatuses = [] } = useGetList<OrderStatus>(Resources.NewOrderStatuses);

  const statusValueById = useMemo(
    () => new Map(orderStatuses.map((status) => [status['@id'], status.value as OrderStatuses])),
    [orderStatuses],
  );

  return useCallback(
    (config, orders) => {
      if (!orders.length) {
        return false;
      }

      const isOrderAllowed = (order: OrderAdjustmentsOrder) => {
        const statusValue = statusValueById.get(order.status);

        return (
          !!statusValue &&
          config.allowedStatuses.includes(statusValue) &&
          config.allowedDirections.includes(order.direction)
        );
      };

      return orders.every(isOrderAllowed);
    },
    [statusValueById],
  );
}
